import React from "react";
import {IconButton} from '@material-ui/core'
import {  
  ExpandMore as ExpandMoreIcon,
  ExpandLess as  ExpandLessIcon
} from "@material-ui/icons";
import {withStyles} from "@material-ui/core";
import Moment from 'moment';
import {inject} from 'mobx-react';

const CalendarioMinimizadoSemana = (props) =>{
  const { classes, semanaAnterior, semanaPosterior, onClickCurrentDayButton, atendimentoStore } = props;

  const semana = () =>{
    const start = Moment(atendimentoStore.selectedDate).day(0);
    const end = Moment(atendimentoStore.selectedDate).day(6);

    return `${start.format("DD")} à ${end.format("DD")}`  
  };

  return(
    <div className={classes.divDataAtualMinimizado}>
      <div id="agd-cms-div-ant" onClick={semanaAnterior}>
        <ExpandLessIcon className={classes.botoesMudarDia}/>
      </div>
      <div className={classes.dataAtual}> {semana()} </div>
      <div id="agd-cms-div-pos" onClick={
        semanaPosterior}>
        <ExpandMoreIcon className={classes.botoesMudarDia}/>
      </div>
      <IconButton
          id="agd-cms-btn-hoj"
          onClick={onClickCurrentDayButton}
          className={classes.botaoDataAtual}
      >
          Hoje
      </IconButton>
  </div>
  )
}

const styles = theme => ({
  divDataAtualMinimizado:{
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    marginBottom: 15,
  },
  botoesMudarDia:{
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0.54)', 
    marginRight: '-5px'
  },
  dataAtual:{
    color: '#009A97',
    cursor: 'pointer',
    padding: '0px 0px 3px 0px',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  botaoDataAtual:{
    borderRadius: 0,
    padding: 7,
    fontSize: 14,
    color: '#27B0AD',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    marginTop: 10,
  },
  
})

const CalendarioMinimizadoSemanaWithStyles = withStyles(styles)(CalendarioMinimizadoSemana);
export default inject("atendimentoStore")(CalendarioMinimizadoSemanaWithStyles);